import React, { memo, PropsWithChildren, useMemo } from 'react';

import { Props } from '@/components/Pagination/types';
import Paginator from '@/ui/components/Paginator';

const Pagination = ({
  children,
  currentPage,
  goToPage,
  nextPage,
  prevPage,
  totalPages
}: PropsWithChildren<Props>) => {
  const paginator = useMemo(() => {
    if (totalPages > 1) {
      return (
        <div className="m-1">
          <Paginator
            currentPage={currentPage}
            goToPage={goToPage}
            nextPage={nextPage}
            prevPage={prevPage}
            totalPages={totalPages}
          />
        </div>
      );
    }

    return null;
  }, [currentPage, goToPage, nextPage, prevPage, totalPages]);

  return (
    <>
      {paginator}
      {children}
      {paginator}
    </>
  );
};

export default memo(Pagination);
